<div class="logo-container">
  <img
    class="logo-container-image"
    alt=""
    src="assets/images/logo-portal-navbar.png"
  />
</div>
<div class="welcome-container">
  <p style="font-size: 20px; font-weight: 500">
    Bem-vindo ao Portal Seminovos!
  </p>
  <p style="font-weight: 400">Entre com a sua conta.</p>
</div>
